<template>
    <div class="componentSty">
        <m-title :titlelist="listitem"></m-title>
        <div class="componentSty_content">
            <div class="componentSty_content_title_flex">
                <div class="componentSty_content_title">
                    <span class="fonints">车队名称</span>
                    <el-input placeholder="请输入关键词" v-model="fleetname" clearable>
                    </el-input>
                    <span class="fonints">上报时间</span>
                    <!-- <el-date-picker v-model="datamsg" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker> -->
                    <el-date-picker
                v-model="starttime"
                type="datetime"
                style="width: 180px;"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="开始日期">
            </el-date-picker>
            至
            <el-date-picker
                  v-model="endtime"
                  type="datetime"
                  style="width: 180px;"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="结束日期">
              </el-date-picker>
                </div>
                <div class="componentSty_content_title_flex_button">
                    <button class="buttons" @click="getjobdetails">查询</button>
                    <button class="buttons" style="color: #17B6A1;background-color: #F3F4F5;"
                        @click="clearjobdetails">重置</button>
                </div>
            </div>

            <div class="componentSty_content_table" style="top: 90px;border:none">
                <el-table :data="arrlist" border style="width: 100%; " height="80%">
                    <el-table-column show-overflow-tooltip label="序号" type="index" width="50px"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="fleetname" label="计划名称"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="gmtModified" label="上报时间">
                        <template v-slot="res">
                            <span>{{ mydateFormat(res.row.gmtModified, "时分秒") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="carcount" label="上报车数"></el-table-column>
                </el-table>
                <div style="text-align: center;">
                    <el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="limit"
                        layout="total, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mTitle from "@/components/mTitle";
export default {
    data() {
        return {
            listitem: [{ name: "上报查询" }, { name: "车辆上报查询" }],
            datamsg: [],
            starttime:"",
            endtime:"",
            arrlist: [],
            fleetname: '',
            limit: 10,
            page: 1,
            total: 0
        };
    },
    computed: {

    },
    components: {
        mTitle,
    },
    created() {
        this.getjobdetails()
    },
    methods: {
        async getjobdetails() {
            const { data } = await this.$http(
                "api1",
                "/api/fleet/reprecord/list",
                "get",
                {
                    fleetname: this.fleetname,
                    starttime: this.starttime,
                    endtime: this.endtime,
                    limit: this.limit,
                    page: this.page
                }
            );
            if (data.code != 0) return this.$message.error(data.msg);

            if (data) {
                this.arrlist = data.data.list;
                this.total = data.data.totalCount
            }
        },
        handleCurrentChange(val) {
            this.page = val
            this.getjobdetails()
        },
        //重置
        clearjobdetails() {
            // this.datamsg = []
            this.starttime=""
            this.endtime=""
            this.fleetname = ""
            this.getjobdetails()
        }
    },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>